/**
 * data-tab-target と data-tab-index を持つアンカーリンクから
 * 対応する .js-tab コンポーネントのタブを切り替える汎用モジュール。
 *
 * 使い方:
 *   <a href="#section-id" data-tab-target="#section-id" data-tab-index="1">アクセス</a>
 *
 * - data-tab-target : タブコンポーネントを含むセクションの CSS セレクター
 * - data-tab-index  : 開きたいタブのインデックス（0始まり）
 */

function switchTab(tabSection, index) {
  const btn = tabSection.querySelectorAll('.js-tab-button')[index];
  if (btn) btn.click();
  tabSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function handleAnchorLinks() {
  document.querySelectorAll('[data-tab-target][data-tab-index]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const tabSection = document.querySelector(link.dataset.tabTarget);
      if (!tabSection) return;
      e.preventDefault();
      switchTab(tabSection, parseInt(link.dataset.tabIndex, 10));
    });
  });
}

function handleHashOnLoad() {
  if (!location.hash) return;
  const matched = document.querySelector(
    `[data-tab-target][data-tab-index][href="${location.hash}"]`
  );
  if (!matched) return;
  const tabSection = document.querySelector(matched.dataset.tabTarget);
  if (!tabSection) return;
  switchTab(tabSection, parseInt(matched.dataset.tabIndex, 10));
}

handleAnchorLinks();
handleHashOnLoad();
